import type { RideRequest } from './MobilityProvider'
import { KRideProvider } from './KRideProvider'
import { UberProvider } from './UberProvider'

export type MobilityRouterErrorCode = 'RIDE_REQUEST_REQUIRED'

export class MobilityRouterError extends Error {
  constructor(readonly code: MobilityRouterErrorCode) {
    super(code)
    this.name = 'MobilityRouterError'
  }
}

export class MobilityRouter {
  constructor(
    readonly kride: KRideProvider,
    readonly uber: UberProvider,
  ) {}

  buildKRideUrl(): string {
    return this.kride.buildAppStartUrl()
  }

  buildUberUrl(request: RideRequest): string {
    return this.uber.buildRideUrl(request)
  }

  openKRide(): void {
    this.kride.openApp()
  }

  openUber(request: RideRequest | null): void {
    if (!request) throw new MobilityRouterError('RIDE_REQUEST_REQUIRED')
    this.uber.openRideRequest(request)
  }
}
